import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VTooltip from 'v-tooltip'
import '@fortawesome/fontawesome-free'
import './assets/scss/style.scss'
import '@fortawesome/fontawesome-free/css/all.min.css'
// Sweet Alert 2
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import vuetify from './plugins/vuetify'
import VueSocketIO from 'vue-socket.io'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import VueChatScroll from 'vue-chat-scroll-top-scroll'
import VueApexCharts from 'vue-apexcharts'
import Toasted from 'vue-toasted'
import i18n from './i18n'
Vue.use(Toasted)
Vue.use(VueApexCharts)
Vue.use(VTooltip)
Vue.component('apexchart', VueApexCharts)

export const bus = new Vue()
Vue.use(VueChatScroll)

const UserRepository = RepositoryFactory.get('users')

console.log('KujiraCRM version: ', process.env.VERSION || '00')

Vue.use(VueSweetalert2)

if (window.Notification && Notification.permission !== 'blocked' && Notification.permission !== 'granted') {
  try {
    Notification.requestPermission().then(function (status) {
      console.log(`Permission ${status}`)
    })
  } catch (error) {
    // Safari doesn't return a promise for requestPermissions and it
    // throws a TypeError. It takes a callback as the first argument
    // instead.
    if (error instanceof TypeError) {
      Notification.requestPermission(() => {
        console.log(`Permission ${status}`)
      })
    } else {
      throw error
    }
  }
}

Vue.use(new VueSocketIO({
  debug: true,
  connection: process.env.VUE_APP_ENV_BASE_URL_API,
  autoConnect: false
}))

Vue.config.productionTip = false
Vue.config.devtools = true

const createVueApp = async () => {
  const resultInfoUser = await UserRepository.getInfo()
  if (resultInfoUser.status_code === 200) {
    await store.dispatch('user/setUserInfo', { ...resultInfoUser.user })
    await store.dispatch('user/refreshTwilioToken', {
      taskRouterToken: resultInfoUser.task_router_token,
      twilioClientAccessToken: resultInfoUser.twilio_client_access_token
    })
    if (resultInfoUser.user && resultInfoUser.user.company.can_chat && resultInfoUser.user.company.disabled_phone) {
      store.commit('user/SET_IS_A_CAST', true)
    }
    if (resultInfoUser.user && !resultInfoUser.user.company.disabled_phone) {
      store.commit('user/SET_IS_A_CAST', false)
    }
    if (resultInfoUser.user && !resultInfoUser.user.company.can_chat && resultInfoUser.user.company.disabled_phone) {
      await router.push({ name: 'NotPage' })
    }
  }
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

createVueApp()
